import {useEffect} from 'react';

// import { Link } from 'react-router-dom';
import ExhibitionEventsLogistics from './ExhibitionEventLogistics';
import ProfessionalTeam from './ProfessionalTeam';
import Tracking from './Tracking';
import Transportation from './Transportation';




const ExpoLogistics = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
  
  
    return(
        <div>
            <div id='international' className="expo-logistics-image">
                <img src='/expo-logistics/Expo-Logistics-Product-Banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] pb-[1rem]">
                <p>
                    TCS Expo Logistics arm provides supply chain management services with plans, implementation, 
                    and control of efficient forward and reverse flow and storage of goods, services, and related 
                    information between points of origin and point of exhibition in order to meet complex and 
                    strictly time-sensitive needs of customers.
                </p>
                <p>
                 TCS teams with exceptional hands-on experience, the largest logistics network and services ensure 
                 secure and reliable solutions for planning, shipping, handling, storage and transportation of 
                 equipment and installations across the country.
                </p>
            </div>


            <ExhibitionEventsLogistics/>
            <ProfessionalTeam/>
            <Tracking/>
            <Transportation/>
        </div>
    )
};
export default ExpoLogistics ;